import {
  Airfryer,
  AntiInflamitory,
  BellPepper,
  Blender,
  Cilantro,
  Crockpot,
  Eggplant,
  Garlic,
  Grill,
  GutHealth,
  HighProtein,
  Immunity,
  LowCarb,
  LowSodium,
  LowSugar,
  Microwave,
  Mushrooms,
  Onion,
  Oven,
  Potatoes,
  StoveTop,
  Tomatoes,
} from '@hungryroot/icons';
import { tags } from '@hungryroot/tags';

export function getTagDetails(tagId: number) {
  switch (tagId) {
    case tags.Fusion:
      return {
        name: 'Fusion',
      };
    case tags.Korean:
      return {
        name: 'Korean',
      };
    case tags.Japanese:
      return {
        name: 'Japanese',
      };
    case tags.Chinese:
      return {
        name: 'Chinese',
      };
    case tags.Thai:
      return {
        name: 'Thai',
      };
    case tags.Italian:
      return {
        name: 'Italian',
      };
    case tags.American:
      return {
        name: 'American',
      };
    case tags.Mexican:
      return {
        name: 'Mexican',
      };
    case tags.Mediterranean:
      return {
        name: 'Mediterranean',
      };
    case tags.Indian:
      return {
        name: 'Indian',
      };
    case tags.Grill:
      return {
        name: 'Grill',
        icon: <Grill />,
      };
    case tags.Airfryer:
      return {
        name: 'Airfryer',
        icon: <Airfryer />,
      };
    case tags.Microwave:
      return {
        name: 'Microwave',
        icon: <Microwave />,
      };
    case tags.Blender:
      return {
        name: 'Blender',
        icon: <Blender />,
      };
    case tags.Crockpot:
      return {
        name: 'Crockpot',
        icon: <Crockpot />,
      };
    case tags.Stove:
      return {
        name: 'Stove',
        icon: <StoveTop />,
      };
    case tags.Oven:
      return {
        name: 'Oven',
        icon: <Oven />,
      };
    case tags.Onions:
      return {
        name: 'Onions',
        icon: <Onion />,
      };
    case tags.Garlic:
      return {
        name: 'Garlic',
        icon: <Garlic />,
      };
    case tags.Mushrooms:
      return {
        name: 'Mushrooms',
        icon: <Mushrooms />,
      };
    case tags.Cilantro:
      return {
        name: 'Cilantro',
        icon: <Cilantro />,
      };
    case tags.BellPeppers:
      return {
        name: 'Bell Peppers',
        icon: <BellPepper />,
      };
    case tags.Tomatoes:
      return {
        name: 'Tomatoes',
        icon: <Tomatoes />,
      };
    case tags.Eggplants:
      return {
        name: 'Eggplants',
        icon: <Eggplant />,
      };
    case tags.Potatoes:
      return {
        name: 'Potatoes',
        icon: <Potatoes />,
      };
    case tags.CarbConscious:
      return {
        name: 'Carb Conscious',
        subtext: '<30g carbs',
        icon: <LowCarb />,
      };
    case tags.LessSugar:
      return {
        name: 'Less Sugar',
        subtext: '<2g added sugar',
        icon: <LowSugar />,
      };
    case tags.HighProtein:
      return {
        name: 'High Protein',
        subtext: '>25g protein',
        icon: <HighProtein />,
      };
    case tags.LowSodium:
      return {
        name: 'Less Sodium',
        subtext: '<800mg sodium',
        icon: <LowSodium />,
      };
    case tags.AntiInflamitory:
      return {
        name: 'Anti-inflammatory',
        subtext: 'Grains, fish + veggies',
        icon: <AntiInflamitory />,
      };
    case tags.GutFriendly:
      return {
        name: 'Gut friendly',
        subtext: 'Probiotic-rich recipes',
        icon: <GutHealth />,
      };
    case tags.ImmunityBoosting:
      return {
        name: 'Immunity boosting',
        subtext: 'Packed with Vitamin C',
        icon: <Immunity />,
      };
    case tags.Burritos:
      return {
        name: 'Burritos',
      };
    case tags.Tamales:
      return {
        name: 'Tamales',
      };
    case tags.Salads:
      return {
        name: 'Salads',
      };
    case tags.Sandwiches:
      return {
        name: 'Sandwiches',
      };
    case tags.Pizza:
      return {
        name: 'Pizza',
      };
    case tags.Trays:
      return {
        name: 'Trays',
      };
    case tags.Soups:
      return {
        name: 'Soups',
      };
    case tags.Bowls:
      return {
        name: 'Bowls',
      };

    default:
      return {};
  }
}
